"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _pureReactCarousel = require("pure-react-carousel");

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledMediaQuery = _interopRequireDefault(require("styled-media-query"));

var _gatsbyImage = _interopRequireDefault(require("gatsby-image"));

var _useLinkAttributes = _interopRequireDefault(require("../useLinkAttributes"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    padding-bottom: 0;\n  "]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    max-height: none;\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    margin-bottom: 0;\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var LINK = 'link';

var ImageContainer = _styledComponents["default"].div.withConfig({
  displayName: "LadderSlide__ImageContainer",
  componentId: "sojjlo-0"
})(["display:block;height:8rem;position:relative;width:100%;"]);

var ImageText = _styledComponents["default"].span.withConfig({
  displayName: "LadderSlide__ImageText",
  componentId: "sojjlo-1"
})(["display:-webkit-box;font-size:0.875rem;font-weight:400;line-height:1;margin:0.5rem 0 1rem;max-height:2rem;-webkit-line-clamp:3;-webkit-box-orient:vertical;", " ", ""], _styledMediaQuery["default"].lessThan('large')(_templateObject()), _styledMediaQuery["default"].lessThan('medium')(_templateObject2()));

var SlideWrapper = (0, _styledComponents["default"])(_pureReactCarousel.Slide).withConfig({
  displayName: "LadderSlide__SlideWrapper",
  componentId: "sojjlo-2"
})(["height:12rem;", ""], function (_ref) {
  var role = _ref.role;
  return role === LINK ? (0, _styledComponents.css)(["cursor:pointer;span{text-decoration:underline;}"]) : undefined;
});

var SlideContent = _styledComponents["default"].article.withConfig({
  displayName: "LadderSlide__SlideContent",
  componentId: "sojjlo-3"
})(["overflow:hidden;padding:0 0 1rem;margin:0;", ""], _styledMediaQuery["default"].lessThan('large')(_templateObject3()));

var LadderSlide = function LadderSlide(_ref2) {
  var currentSlide = _ref2.currentSlide,
      title = _ref2.title,
      rest = _objectWithoutProperties(_ref2, ["currentSlide", "title"]);

  var attrs = (0, _useLinkAttributes["default"])(_objectSpread({
    title: title
  }, rest));
  return /*#__PURE__*/_react["default"].createElement(SlideWrapper, _extends({
    index: currentSlide
  }, attrs), /*#__PURE__*/_react["default"].createElement(SlideContent, null, /*#__PURE__*/_react["default"].createElement(ImageContainer, null, /*#__PURE__*/_react["default"].createElement(_gatsbyImage["default"], rest)), /*#__PURE__*/_react["default"].createElement(ImageText, {
    id: attrs['aria-labelledby']
  }, title)));
};

LadderSlide.propTypes = {
  currentSlide: _propTypes["default"].number.isRequired,
  fluid: _propTypes["default"].shape({
    src: _propTypes["default"].string
  }).isRequired,
  title: _propTypes["default"].string.isRequired,
  href: _propTypes["default"].string,
  redirect: _propTypes["default"].func,
  alt: _propTypes["default"].string.isRequired,
  style: _propTypes["default"].shape({
    height: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
    width: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string])
  })
};
LadderSlide.defaultProps = {
  href: '',
  redirect: undefined,
  style: {
    height: '100%',
    width: '100%'
  }
};
var _default = LadderSlide;
exports["default"] = _default;